module.exports = __webpack_public_path__ + "img/iriomote_6.86f22877.jpg";